module.exports = __webpack_public_path__ + "static/media/GB_Map2.5b45ce91.jpg";